<!--===========================
=            CARDS            =
============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Cards</div>
      </base-header>
    </v-row>
    <v-row>
      <template>
        

        <v-col cols="12" md="3" sm="12">
          <v-card class="rounded-lg white--text"  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline white--text ">
                  OVERLINE
                </div>
                <v-list-item-title class="text-h5 white--text mb-1">
                  Headline 5
                </v-list-item-title>
                <v-list-item-subtitle class="white--text">Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle>
              </v-list-item-content>

             <v-list-item-avatar tile size="80" color="transparent"><img  alt=""
                         src="../../assets/images/icons/dicas.png"></v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
              <v-btn outlined dark rounded text>
                Button
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-col>
        <v-col cols="12" md="3" sm="12">
         <v-card class="rounded-lg white--text"  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline white--text ">
                  OVERLINE
                </div>
                <v-list-item-title class="text-h5 white--text mb-1">
                  Headline 5
                </v-list-item-title>
                <v-list-item-subtitle class="white--text">Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle>
              </v-list-item-content>


              <v-list-item-avatar tile size="80" color="transparent"><img  alt=""
                         src="../../assets/images/icons/balao-de-fala.png"></v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
              <v-btn outlined dark rounded text>
                Button
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-col>
        <v-col cols="12" md="3" sm="12">
          <v-card class="rounded-lg white--text"  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline white--text ">
                  OVERLINE
                </div>
                <v-list-item-title class="text-h5 white--text mb-1">
                  Headline 5
                </v-list-item-title>
                <v-list-item-subtitle class="white--text">Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle>
              </v-list-item-content>


             <v-list-item-avatar tile size="80" color="transparent"><img  alt=""
                         src="../../assets/images/icons/desktop.png"></v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
              <v-btn outlined dark rounded text>
                Button
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-col>
        <v-col cols="12" md="3" sm="12">
          <v-card class="rounded-lg white--text"  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline white--text ">
                  OVERLINE
                </div>
                <v-list-item-title class="text-h5 white--text mb-1">
                  Headline 5
                </v-list-item-title>
                <v-list-item-subtitle class="white--text">Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle>
              </v-list-item-content>


              <v-list-item-avatar tile size="80" color="transparent"><img  alt=""
                         src="../../assets/images/icons/livro.png"></v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
              <v-btn outlined dark rounded text>
                Button
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-col>
      
        </v-col>
      </template>
    </v-row>
    <v-row>
      <template>
       
 <v-col cols="12" md="4" sm="12">
          <v-card class="mx-auto" color="#3b5998" dark>
            <v-card-title>
              <v-icon large left>
                mdi-facebook
              </v-icon>
              <span class="text-h6 font-weight-light">facebook</span>
            </v-card-title>

            <v-card-text class="subtitle-1  font-weight-bold">
              "Turns out semicolon-less style is easier and safer in TS because most gotcha edge cases are type invalid
              as well."
            </v-card-text>

            <v-card-actions>
              <v-list-item class="grow">
                <v-list-item-avatar color="grey darken-3">
                  <v-img class="elevation-6" alt=""
                         src="../../assets/images/2.png">
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>Evan You</v-list-item-title>
                </v-list-item-content>

                <v-row align="center" justify="end">
                  <v-icon class="mr-1">
                    mdi-heart
                  </v-icon>
                  <span class="subheading mr-2">256</span>
                  <span class="mr-1">·</span>
                  <v-icon class="mr-1">
                    mdi-share-variant
                  </v-icon>
                  <span class="subheading">45</span>
                </v-row>
              </v-list-item>
            </v-card-actions>
          </v-card>

        </v-col>
        <v-col cols="12" md="4" sm="12">
          <v-card class="mx-auto" color="#26c6da" dark>
            <v-card-title>
              <v-icon large left>
                mdi-twitter
              </v-icon>
              <span class="text-h6 font-weight-light">Twitter</span>
            </v-card-title>

              <v-card-text class="subtitle-1  font-weight-bold">
              "Turns out semicolon-less style is easier and safer in TS because most gotcha edge cases are type invalid
              as well."
            </v-card-text>

            <v-card-actions>
              <v-list-item class="grow">
                <v-list-item-avatar color="grey darken-3">
                  <v-img class="elevation-6" alt=""
                     src="../../assets/images/2.png">
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>Evan You</v-list-item-title>
                </v-list-item-content>

                <v-row align="center" justify="end">
                  <v-icon class="mr-1">
                    mdi-heart
                  </v-icon>
                  <span class="subheading mr-2">256</span>
                  <span class="mr-1">·</span>
                  <v-icon class="mr-1">
                    mdi-share-variant
                  </v-icon>
                  <span class="subheading">45</span>
                </v-row>
              </v-list-item>
            </v-card-actions>
          </v-card>

        </v-col><v-col cols="12" md="4" sm="12">
          <v-card class="mx-auto" color="pink" dark>
            <v-card-title>
              <v-icon large left>
                mdi-instagram
              </v-icon>
              <span class="text-h6 font-weight-light">Instagram</span>
            </v-card-title>

              <v-card-text class="subtitle-1  font-weight-bold">
              "Turns out semicolon-less style is easier and safer in TS because most gotcha edge cases are type invalid
              as well."
            </v-card-text>

            <v-card-actions>
              <v-list-item class="grow">
                <v-list-item-avatar color="grey darken-3">
                  <v-img class="elevation-6" alt=""
                         src="../../assets/images/2.png">
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>Evan You</v-list-item-title>
                </v-list-item-content>

                <v-row align="center" justify="end">
                  <v-icon class="mr-1">
                    mdi-heart
                  </v-icon>
                  <span class="subheading mr-2">256</span>
                  <span class="mr-1">·</span>
                  <v-icon class="mr-1">
                    mdi-share-variant
                  </v-icon>
                  <span class="subheading">45</span>
                </v-row>
              </v-list-item>
            </v-card-actions>
          </v-card>

        </v-col>
      

      </template>
    </v-row>
    <v-row > 
      <v-col v-for="card in cards" :key="card.title" :cols="card.flex">
        <v-card>
          <v-img :src="card.src" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                 height="200px">
            <v-card-title v-text="card.title"></v-card-title>
          </v-img>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>

            <v-btn icon>
              <v-icon>mdi-bookmark</v-icon>
            </v-btn>

            <v-btn icon>
              <v-icon>mdi-share-variant</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data: () => ({
      cards: [{
          title: 'Pre-fab homes',
          src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg',
          flex: 4
        },
        {
          title: 'Favorite road trips',
          src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg',
          flex: 4
        },
        {
          title: 'Best airlines',
          src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg',
          flex: 4
        },
      ],
    }),

  }
</script>

<!--====  End of CARDS  ====-->
